import React, { useState, useEffect } from "react";
import {
    ThemeProvider,
    Typography,
    Grid,
    Box,
    Card,
    CardHeader,
    CardContent,
    Breadcrumbs,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    CircularProgress,
    TextField,
    Button,
    Paper
} from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { styled } from "@mui/material/styles";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import { createTheme } from "@mui/material/styles";
import { getTechnicians } from "../API/technicianAPI";
import { getJobOrders } from "../API/jobOrderAPI";
import BaseWrapper from "../../components/shared/BaseWrapper";
const theme = createTheme({
    palette: {
        primary: {
            main: "#1e5d45", // Custom primary color
        },
    },
});

const StyledHr = styled("hr")(({ theme }) => ({
    border: 0,
    borderTop: `1px solid ${theme.palette.divider}`,
    // margin: theme.spacing(4, 0),
    opacity: 0.8,
}));

const formatTime = (time) => {
    if (!time) return "N/A";  // Handle cases where time might be missing

    const [hours, minutes] = time.split(":");
    const hour = parseInt(hours, 10);
    const period = hour >= 12 ? "PM" : "AM";
    const formattedHour = hour % 12 || 12; // Convert 0 to 12 for midnight

    return `${formattedHour}:${minutes} ${period}`;
};


function ViewOperationCompletionReport() {

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false); // State to manage loading
    const [searchFilter, setSearchFilter] = useState({
        startDate: (() => {
            const now = new Date();
            const philippineTimezoneOffset = 8 * 60; // UTC+8 in minutes
            now.setMinutes(now.getMinutes() + philippineTimezoneOffset);
            return now.toISOString().split("T")[0];  // Return today's date
        })(),
    });
    const [operationCompletionData, setOperationCompletionData] = useState([])



    const handleSubmitButtonClick = async () => {
        try {
            // Fetch job orders with the corrected clientId
            const jobOrderResults = await getJobOrders(
                [],
                [],
                [],
                searchFilter.startDate,
                searchFilter.startDate,
                null
            );

            // Process job orders to extract unique technicians and their job orders
            const technicianMap = new Map();

            jobOrderResults.forEach((jobOrder) => {
                jobOrder.technicians.forEach((tech) => {
                    const techKey = `${tech.firstname}_${tech.lastname}`;
                    if (!technicianMap.has(techKey)) {
                        technicianMap.set(techKey, {
                            firstname: tech.firstname,
                            lastname: tech.lastname,
                            job_orders: []
                        });
                    }

                    // Generate job_scope based on filtered competencies
                    const jobScope = jobOrder.competencies
                        ?.filter(
                            (competency) =>
                                competency !== "driving_2_wheels" &&
                                competency !== "driving_4_wheels" &&
                                competency !== "basic_safety"
                        )
                        .map((competency) => {
                            const formattedCompetency = competency
                                .replace(/_/g, " ") // Replace underscores with spaces
                                .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word

                            const specializationKey =
                                competency === "general_pest_control"
                                    ? "general_pest_control"
                                    : "termite";

                            const formattedSpecialization = (
                                jobOrder.specialization?.[specializationKey] || []
                            ).map((word) =>
                                word
                                    .replace(/_/g, " ")
                                    .split(" ")
                                    .map(
                                        (w) =>
                                            w.length === 2
                                                ? w.toUpperCase()
                                                : w.charAt(0).toUpperCase() + w.slice(1)
                                    )
                                    .join(" ")
                            );

                            return {
                                competency: formattedCompetency,
                                specialization: formattedSpecialization,
                            };
                        }) || [];

                    // Determine the appropriate receipt URL
                    const receiptUrl = jobOrder.competencies.includes("termite_control")
                        ? jobOrder.receipt_termite_url
                        : jobOrder.receipts_url;




                    technicianMap.get(techKey).job_orders.push({
                        client_name: jobOrder.client?.name || "",
                        start_time: jobOrder.start_time,
                        end_time: jobOrder.end_time,
                        job_scope: jobScope, // Replacing competencies with job_scope
                        status: jobOrder.status,
                        service_report_status: jobOrder.service_report_status,
                        receipts_url: receiptUrl || "",
                        certification_url: jobOrder.certificate_url || "",
                        reports_url: jobOrder.reports_url || "",
                        endorsement_form_id: jobOrder.endorsement_form_id || ""
                    });
                });
            });


            // Convert map to list of technicians
            const transformedData = Array.from(technicianMap.values());

            // Sort by lastname A to Z
            transformedData.sort((a, b) => a.lastname.localeCompare(b.lastname));

            // Update state with transformed data
            setOperationCompletionData(transformedData);
            setError(null); // Clear any previous errors
        } catch (err) {
            setError(err.message);
            setLoading(false);
        }
    };





    return (

        <BaseWrapper
            titleIcon={<TaskAltIcon />}
            title="Operations"
            subTitle="View Operation Completion Report"
            subTitleRoute={"/view-operation-completion-report"}
            // createButtonLabel="Create Service Report"
            // onClickCreateButton={() => navigate("/create-service-report")}
            successMessage={successMessage}
            setSuccessMessage={setSuccessMessage}
            errorMessage={errorMessage}
            setErrorMessage={setErrorMessage}
            isLoading={isLoading}
        >
            <Grid item xs={12} sm={12}>
                <Grid container spacing={3} sx={{ mb: 2 }} alignItems="center">
                    <Grid item xs={12} sm={2} md={2}>
                        <TextField
                            label="Date"
                            type="date"
                            variant="outlined"
                            fullWidth
                            InputLabelProps={{
                                shrink: true,
                            }}
                            value={searchFilter.startDate}
                            onChange={(e) =>
                                setSearchFilter((prev) => ({
                                    ...prev,
                                    startDate: e.target.value,
                                }))
                            }
                        />
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        sm={12}
                        md={2}
                        container
                    // justifyContent="flex-end"
                    >
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleSubmitButtonClick}
                            disabled={isLoading}
                        >
                            {isLoading ? "Submitting..." : "Submit"}
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
            <StyledHr />



            {operationCompletionData && operationCompletionData.length > 0 && (
                <Grid item xs={12}>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell
                                    sx={{
                                        fontSize: "0.8rem",
                                        fontWeight: "bold",
                                        padding: "6px",
                                        backgroundColor: "#f7f7f7"
                                    }}
                                >
                                    Technician
                                </TableCell>
                                <TableCell
                                    sx={{
                                        fontSize: "0.8rem",
                                        fontWeight: "bold",
                                        padding: "6px",
                                        backgroundColor: "#f7f7f7"
                                    }}
                                >
                                    Client Name
                                </TableCell>
                                <TableCell
                                    sx={{
                                        fontSize: "0.8rem",
                                        fontWeight: "bold",
                                        padding: "6px",
                                        backgroundColor: "#f7f7f7"
                                    }}
                                >
                                    Scope
                                </TableCell>

                                <TableCell
                                    sx={{
                                        fontSize: "0.8rem",
                                        fontWeight: "bold",
                                        padding: "6px",
                                        backgroundColor: "#f7f7f7"
                                    }}
                                >
                                    Start Time
                                </TableCell>
                                <TableCell
                                    sx={{
                                        fontSize: "0.8rem",
                                        fontWeight: "bold",
                                        padding: "6px",
                                        backgroundColor: "#f7f7f7"
                                    }}
                                >
                                    End Time
                                </TableCell>
                                <TableCell
                                    sx={{
                                        fontSize: "0.8rem",
                                        fontWeight: "bold",
                                        padding: "6px",
                                        backgroundColor: "#f7f7f7"
                                    }}
                                >
                                    Status
                                </TableCell>
                                <TableCell
                                    sx={{
                                        fontSize: "0.8rem",
                                        fontWeight: "bold",
                                        padding: "6px",
                                        backgroundColor: "#f7f7f7"
                                    }}
                                >
                                    Reports URL
                                </TableCell>
                                <TableCell
                                    sx={{
                                        fontSize: "0.8rem",
                                        fontWeight: "bold",
                                        padding: "6px",
                                        backgroundColor: "#f7f7f7"
                                    }}
                                >
                                    Receipts URL
                                </TableCell>
                                <TableCell
                                    sx={{
                                        fontSize: "0.8rem",
                                        fontWeight: "bold",
                                        padding: "6px",
                                        backgroundColor: "#f7f7f7"
                                    }}
                                >
                                    Certificate URL
                                </TableCell>
                                <TableCell
                                    sx={{
                                        fontSize: "0.8rem",
                                        fontWeight: "bold",
                                        padding: "6px",
                                        backgroundColor: "#f7f7f7"
                                    }}
                                >
                                    Service Report Status
                                </TableCell>
                                <TableCell
                                    sx={{
                                        fontSize: "0.8rem",
                                        fontWeight: "bold",
                                        padding: "6px",
                                        backgroundColor: "#f7f7f7"
                                    }}
                                >
                                    Endorsement ID
                                </TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {operationCompletionData.map((technician, tIndex) => (
                                <React.Fragment key={tIndex}>
                                    {technician.job_orders.map((order, oIndex) => (
                                        <TableRow key={oIndex}>
                                            {oIndex === 0 && (
                                                <TableCell
                                                    rowSpan={technician.job_orders.length}
                                                    sx={{
                                                        fontSize: "0.75rem",
                                                        padding: "6px",
                                                        fontWeight: "bold"
                                                    }}
                                                >
                                                    {`${technician.firstname} ${technician.lastname}`}
                                                </TableCell>
                                            )}
                                            <TableCell sx={{ fontSize: "0.75rem", padding: "6px" }}>
                                                {order.client_name}
                                            </TableCell>
                                            <TableCell sx={{ fontSize: "0.75rem", padding: "6px" }}>
                                                <ol style={{ paddingLeft: "16px", margin: 0 }}>
                                                    {order.job_scope.length > 0 ? (
                                                        order.job_scope.map((scope, index) => {
                                                            const formattedCompetency =
                                                                scope.competency.toLowerCase() === "qpms"
                                                                    ? "QPMS"
                                                                    : scope.competency
                                                                        .toLowerCase()
                                                                        .replace(/_/g, " ")
                                                                        .replace(/\b\w/g, (char) => char.toUpperCase());

                                                            return (
                                                                <li key={index}>
                                                                    {formattedCompetency}
                                                                    {scope.specialization.length > 0
                                                                        ? `: ${scope.specialization.join(", ")}`
                                                                        : ""}
                                                                </li>
                                                            );
                                                        })
                                                    ) : (
                                                        <li>N/A</li>
                                                    )}
                                                </ol>
                                            </TableCell>
                                            <TableCell
                                                sx={{ fontSize: "0.75rem", padding: "6px" }}
                                            >
                                                {formatTime(order.start_time)}
                                            </TableCell>
                                            <TableCell
                                                sx={{ fontSize: "0.75rem", padding: "6px" }}
                                            >
                                                {formatTime(order.end_time)}
                                            </TableCell>

                                            <TableCell
                                                sx={{ fontSize: "0.75rem", padding: "6px" }}
                                            >
                                                {order.status}
                                            </TableCell>
                                            <TableCell
                                                sx={{ fontSize: "0.75rem", padding: "6px" }}
                                            >
                                                {order.reports_url ? (
                                                    <a
                                                        href={order.reports_url}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        style={{
                                                            color: "#1976d2",
                                                            textDecoration: "none"
                                                        }}
                                                    >
                                                        View Report
                                                    </a>
                                                ) : (
                                                    ""
                                                )}
                                            </TableCell>
                                            <TableCell
                                                sx={{ fontSize: "0.75rem", padding: "6px" }}
                                            >
                                                {order.receipts_url ? (
                                                    <a
                                                        href={order.receipts_url}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        style={{
                                                            color: "#1976d2",
                                                            textDecoration: "none"
                                                        }}
                                                    >
                                                        View Receipt
                                                    </a>
                                                ) : (
                                                    ""
                                                )}
                                            </TableCell>
                                            <TableCell
                                                sx={{ fontSize: "0.75rem", padding: "6px" }}
                                            >
                                                {order.certification_url ? (
                                                    <a
                                                        href={order.certification_url}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        style={{
                                                            color: "#1976d2",
                                                            textDecoration: "none"
                                                        }}
                                                    >
                                                        View Certificate
                                                    </a>
                                                ) : (
                                                    ""
                                                )}
                                            </TableCell>
                                            <TableCell
                                                sx={{ fontSize: "0.75rem", padding: "6px" }}
                                            >
                                                {order.service_report_status}
                                            </TableCell>
                                            <TableCell
                                                sx={{ fontSize: "0.75rem", padding: "6px" }}
                                            >
                                                {order.endorsement_form_id}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </React.Fragment>
                            ))}
                        </TableBody>
                    </Table>
                </Grid>
            )}
        </BaseWrapper>
        // <ThemeProvider theme={theme}>
        //     <Box sx={{ padding: "40px 60px" }}>
        //         <Card
        //             variant="outlined"
        //             style={{
        //                 marginTop: "40px",
        //                 marginBottom: "40px",
        //                 borderRadius: 0,
        //             }}
        //         >
        //             <CardHeader
        //                 title={
        //                     <Box
        //                         display="flex"
        //                         alignItems="center"
        //                         justifyContent="space-between"
        //                     >
        //                         <Box display="flex" alignItems="center">
        //                             <TaskAltIcon
        //                                 sx={{
        //                                     fontSize: "40px",
        //                                     marginRight: "8px",
        //                                 }}
        //                             />
        //                             <Typography variant="h6">Operations</Typography>
        //                         </Box>
        //                         <Breadcrumbs
        //                             aria-label="breadcrumb"
        //                             separator={<NavigateNextIcon fontSize="small" />}
        //                             sx={{ color: "white" }}
        //                         >
        //                             <Typography sx={{ color: "#ffffff99" }}>
        //                                 Operations
        //                             </Typography>
        //                             <Typography sx={{ color: "#ffffff", textDecoration: "none" }}>
        //                                 View Operation Completion Report
        //                             </Typography>
        //                         </Breadcrumbs>
        //                     </Box>
        //                 }
        //                 sx={{
        //                     backgroundColor: "#1e5d45",
        //                     color: "white",
        //                     padding: "16px",
        //                 }}
        //             />
        //             <CardContent sx={{ padding: "20px" }}>
        //                 <Card variant="outlined" sx={{ padding: "20px" }}>
        //                     <CardHeader
        //                         title={
        //                             <Typography variant="h5" sx={{ fontWeight: "bold" }}>
        //                                 Operation Completion Report
        //                             </Typography>
        //                         }
        //                         sx={{ marginBottom: 2 }}
        //                     />
        //                     <Grid item xs={12} sm={12}>
        //                         <Grid container spacing={3} sx={{ mb: 2 }} alignItems="center">
        //                             <Grid item xs={12} sm={2} md={2}>
        //                                 <TextField
        //                                     label="Date"
        //                                     type="date"
        //                                     variant="outlined"
        //                                     fullWidth
        //                                     InputLabelProps={{
        //                                         shrink: true,
        //                                     }}
        //                                     value={searchFilter.startDate}
        //                                     onChange={(e) =>
        //                                         setSearchFilter((prev) => ({
        //                                             ...prev,
        //                                             startDate: e.target.value,
        //                                         }))
        //                                     }
        //                                 />
        //                             </Grid>
        //                             <Grid
        //                                 item
        //                                 xs={12}
        //                                 sm={12}
        //                                 md={2}
        //                                 container
        //                             // justifyContent="flex-end"
        //                             >
        //                                 <Button
        //                                     variant="contained"
        //                                     color="primary"
        //                                     onClick={handleSubmitButtonClick}
        //                                     disabled={isLoading}
        //                                 >
        //                                     {isLoading ? "Submitting..." : "Submit"}
        //                                 </Button>
        //                             </Grid>
        //                         </Grid>
        //                     </Grid>
        //                     <StyledHr />



        //                     {operationCompletionData && operationCompletionData.length > 0 && (
        //                         <Grid item xs={12}>
        //                             <Table size="small">
        //                                 <TableHead>
        //                                     <TableRow>
        //                                         <TableCell
        //                                             sx={{
        //                                                 fontSize: "0.8rem",
        //                                                 fontWeight: "bold",
        //                                                 padding: "6px",
        //                                                 backgroundColor: "#f7f7f7"
        //                                             }}
        //                                         >
        //                                             Technician
        //                                         </TableCell>
        //                                         <TableCell
        //                                             sx={{
        //                                                 fontSize: "0.8rem",
        //                                                 fontWeight: "bold",
        //                                                 padding: "6px",
        //                                                 backgroundColor: "#f7f7f7"
        //                                             }}
        //                                         >
        //                                             Client Name
        //                                         </TableCell>
        //                                         <TableCell
        //                                             sx={{
        //                                                 fontSize: "0.8rem",
        //                                                 fontWeight: "bold",
        //                                                 padding: "6px",
        //                                                 backgroundColor: "#f7f7f7"
        //                                             }}
        //                                         >
        //                                             Scope
        //                                         </TableCell>

        //                                         <TableCell
        //                                             sx={{
        //                                                 fontSize: "0.8rem",
        //                                                 fontWeight: "bold",
        //                                                 padding: "6px",
        //                                                 backgroundColor: "#f7f7f7"
        //                                             }}
        //                                         >
        //                                             Start Time
        //                                         </TableCell>
        //                                         <TableCell
        //                                             sx={{
        //                                                 fontSize: "0.8rem",
        //                                                 fontWeight: "bold",
        //                                                 padding: "6px",
        //                                                 backgroundColor: "#f7f7f7"
        //                                             }}
        //                                         >
        //                                             End Time
        //                                         </TableCell>
        //                                         <TableCell
        //                                             sx={{
        //                                                 fontSize: "0.8rem",
        //                                                 fontWeight: "bold",
        //                                                 padding: "6px",
        //                                                 backgroundColor: "#f7f7f7"
        //                                             }}
        //                                         >
        //                                             Status
        //                                         </TableCell>
        //                                         <TableCell
        //                                             sx={{
        //                                                 fontSize: "0.8rem",
        //                                                 fontWeight: "bold",
        //                                                 padding: "6px",
        //                                                 backgroundColor: "#f7f7f7"
        //                                             }}
        //                                         >
        //                                             Reports URL
        //                                         </TableCell>
        //                                         <TableCell
        //                                             sx={{
        //                                                 fontSize: "0.8rem",
        //                                                 fontWeight: "bold",
        //                                                 padding: "6px",
        //                                                 backgroundColor: "#f7f7f7"
        //                                             }}
        //                                         >
        //                                             Receipts URL
        //                                         </TableCell>
        //                                         <TableCell
        //                                             sx={{
        //                                                 fontSize: "0.8rem",
        //                                                 fontWeight: "bold",
        //                                                 padding: "6px",
        //                                                 backgroundColor: "#f7f7f7"
        //                                             }}
        //                                         >
        //                                             Certificate URL
        //                                         </TableCell>
        //                                         <TableCell
        //                                             sx={{
        //                                                 fontSize: "0.8rem",
        //                                                 fontWeight: "bold",
        //                                                 padding: "6px",
        //                                                 backgroundColor: "#f7f7f7"
        //                                             }}
        //                                         >
        //                                             Service Report Status
        //                                         </TableCell>
        //                                         <TableCell
        //                                             sx={{
        //                                                 fontSize: "0.8rem",
        //                                                 fontWeight: "bold",
        //                                                 padding: "6px",
        //                                                 backgroundColor: "#f7f7f7"
        //                                             }}
        //                                         >
        //                                             Endorsement ID
        //                                         </TableCell>
        //                                     </TableRow>
        //                                 </TableHead>

        //                                 <TableBody>
        //                                     {operationCompletionData.map((technician, tIndex) => (
        //                                         <React.Fragment key={tIndex}>
        //                                             {technician.job_orders.map((order, oIndex) => (
        //                                                 <TableRow key={oIndex}>
        //                                                     {oIndex === 0 && (
        //                                                         <TableCell
        //                                                             rowSpan={technician.job_orders.length}
        //                                                             sx={{
        //                                                                 fontSize: "0.75rem",
        //                                                                 padding: "6px",
        //                                                                 fontWeight: "bold"
        //                                                             }}
        //                                                         >
        //                                                             {`${technician.firstname} ${technician.lastname}`}
        //                                                         </TableCell>
        //                                                     )}
        //                                                     <TableCell sx={{ fontSize: "0.75rem", padding: "6px" }}>
        //                                                         {order.client_name}
        //                                                     </TableCell>
        //                                                     <TableCell sx={{ fontSize: "0.75rem", padding: "6px" }}>
        //                                                         <ol style={{ paddingLeft: "16px", margin: 0 }}>
        //                                                             {order.job_scope.length > 0 ? (
        //                                                                 order.job_scope.map((scope, index) => {
        //                                                                     const formattedCompetency =
        //                                                                         scope.competency.toLowerCase() === "qpms"
        //                                                                             ? "QPMS"
        //                                                                             : scope.competency
        //                                                                                 .toLowerCase()
        //                                                                                 .replace(/_/g, " ")
        //                                                                                 .replace(/\b\w/g, (char) => char.toUpperCase());

        //                                                                     return (
        //                                                                         <li key={index}>
        //                                                                             {formattedCompetency}
        //                                                                             {scope.specialization.length > 0
        //                                                                                 ? `: ${scope.specialization.join(", ")}`
        //                                                                                 : ""}
        //                                                                         </li>
        //                                                                     );
        //                                                                 })
        //                                                             ) : (
        //                                                                 <li>N/A</li>
        //                                                             )}
        //                                                         </ol>
        //                                                     </TableCell>
        //                                                     <TableCell
        //                                                         sx={{ fontSize: "0.75rem", padding: "6px" }}
        //                                                     >
        //                                                         {formatTime(order.start_time)}
        //                                                     </TableCell>
        //                                                     <TableCell
        //                                                         sx={{ fontSize: "0.75rem", padding: "6px" }}
        //                                                     >
        //                                                         {formatTime(order.end_time)}
        //                                                     </TableCell>

        //                                                     <TableCell
        //                                                         sx={{ fontSize: "0.75rem", padding: "6px" }}
        //                                                     >
        //                                                         {order.status}
        //                                                     </TableCell>
        //                                                     <TableCell
        //                                                         sx={{ fontSize: "0.75rem", padding: "6px" }}
        //                                                     >
        //                                                         {order.reports_url ? (
        //                                                             <a
        //                                                                 href={order.reports_url}
        //                                                                 target="_blank"
        //                                                                 rel="noopener noreferrer"
        //                                                                 style={{
        //                                                                     color: "#1976d2",
        //                                                                     textDecoration: "none"
        //                                                                 }}
        //                                                             >
        //                                                                 View Report
        //                                                             </a>
        //                                                         ) : (
        //                                                             ""
        //                                                         )}
        //                                                     </TableCell>
        //                                                     <TableCell
        //                                                         sx={{ fontSize: "0.75rem", padding: "6px" }}
        //                                                     >
        //                                                         {order.receipts_url ? (
        //                                                             <a
        //                                                                 href={order.receipts_url}
        //                                                                 target="_blank"
        //                                                                 rel="noopener noreferrer"
        //                                                                 style={{
        //                                                                     color: "#1976d2",
        //                                                                     textDecoration: "none"
        //                                                                 }}
        //                                                             >
        //                                                                 View Receipt
        //                                                             </a>
        //                                                         ) : (
        //                                                             ""
        //                                                         )}
        //                                                     </TableCell>
        //                                                     <TableCell
        //                                                         sx={{ fontSize: "0.75rem", padding: "6px" }}
        //                                                     >
        //                                                         {order.certification_url ? (
        //                                                             <a
        //                                                                 href={order.certification_url}
        //                                                                 target="_blank"
        //                                                                 rel="noopener noreferrer"
        //                                                                 style={{
        //                                                                     color: "#1976d2",
        //                                                                     textDecoration: "none"
        //                                                                 }}
        //                                                             >
        //                                                                 View Certificate
        //                                                             </a>
        //                                                         ) : (
        //                                                             ""
        //                                                         )}
        //                                                     </TableCell>
        //                                                     <TableCell
        //                                                         sx={{ fontSize: "0.75rem", padding: "6px" }}
        //                                                     >
        //                                                         {order.service_report_status}
        //                                                     </TableCell>
        //                                                     <TableCell
        //                                                         sx={{ fontSize: "0.75rem", padding: "6px" }}
        //                                                     >
        //                                                         {order.endorsement_form_id }
        //                                                     </TableCell>
        //                                                 </TableRow>
        //                                             ))}
        //                                         </React.Fragment>
        //                                     ))}
        //                                 </TableBody>
        //                             </Table>
        //                         </Grid>
        //                     )}




        //                 </Card>
        //             </CardContent>
        //         </Card>
        //     </Box>
        // </ThemeProvider >
    )

}

export default ViewOperationCompletionReport;